"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterName = void 0;
const compact_1 = __importDefault(require("lodash/compact"));
const isString_1 = __importDefault(require("lodash/isString"));
const startCase_1 = __importDefault(require("lodash/startCase"));
function camelMatch(filter, text) {
    if (!text)
        return false;
    if (!filter)
        return true;
    if (filter.replace(/[A-Z]/g, '').length == 0) {
        const textCapitals = (0, startCase_1.default)(text).replace(/[^A-Z]/g, '');
        const pattern = '.*' + filter.split('').join('.*') + '.*';
        const re = new RegExp(pattern);
        return re.test(textCapitals);
    }
    else {
        return text.toUpperCase().includes(filter.toUpperCase());
    }
}
function filterName(filter, ...names) {
    if (!filter)
        return true;
    // const camelVariants = [name.replace(/[^A-Z]/g, '')]
    const tokens = filter.split(' ').map(x => x.trim());
    const namesCompacted = (0, compact_1.default)(names);
    // @ts-ignore
    const namesOwn = namesCompacted.filter(x => (0, isString_1.default)(x));
    // @ts-ignore
    const namesChild = namesCompacted.filter(x => x.childName).map(x => x.childName);
    for (const token of tokens) {
        // const tokenUpper = token.toUpperCase();
        if (token.startsWith('#')) {
            // const tokenUpperSub = tokenUpper.substring(1);
            const found = namesChild.find(name => camelMatch(token.substring(1), name));
            if (!found)
                return false;
        }
        else {
            const found = namesOwn.find(name => camelMatch(token, name));
            if (!found)
                return false;
        }
    }
    return true;
}
exports.filterName = filterName;
